<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined>
        <v-card-text>
          <v-row dense>
            <v-col cols="6">
              <v-text-field dense
                            label="Discount Name"
                            v-model="discountName"
                            :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field dense
                            label="Discount Value"
                            v-model="discountValue"
                            :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" v-if="discountCodeRequired">
              <v-text-field dense
                            label="Discount Code"
                            v-model="discountCode"
                            :rules="[rules.discountCodeRequired]"
              ></v-text-field>
            </v-col>
<!--            <v-col cols="6" v-if="discountCodeRequired">-->
<!--              <v-text-field dense-->
<!--                            label="Usage Times Per User"-->
<!--                            v-model="perUserTimes"-->
<!--              ></v-text-field>-->
<!--            </v-col>-->
          </v-row>
          <v-row dense>
            <v-col cols="6">
              <v-select
                label="Discount Type"
                :multiple="false"
                :chips="false"
                v-model="selectedDiscountType"
                :items="discountTypes"
              >
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Discount Status"
                :multiple="false"
                :chips="false"
                v-model="selectedDiscountStatus"
                :items="discountStatus"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row dense v-if="discountPartnerRequired">
            <v-col cols="6">
              <partner-dropdown
                label="Partner"
                :single="true"
                :partners.sync="partnerId"
                :nochips="true"
                :rules="[rules.required]"
              ></partner-dropdown>
            </v-col>
            <v-col cols="6" v-if="isProductCoupon">
              <v-text-field dense
                            label="Retail User ID (optional)"
                            v-model="retailUserId"
                            :rules="[rules.retailUserId]"
                            hint="Limit to this retail client. Leave blank for all clients."
                            persistent-hint
                            clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense v-if="isProductCoupon">
            <v-col cols="12">
              <v-switch v-model="disableStack"
                        label="Disable stack"
                        :hint="'Apply only this coupon after the member price, if any. '
                          + 'Excludes promo and referral discounts on matching products.'"
                        persistent-hint
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense v-if="discountUsesOperationTypes">
            <v-col cols="6">
              <v-select
                label="Applied Operation Type"
                :multiple="true"
                :chips="true"
                v-model="selectedDiscountOperationTypes"
                :items="discountOperationTypes"
                clearable
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row dense v-if="showDiscountProductCatalogue">
            <v-col cols="6">
              <v-select
                label="Applied Product Type"
                :multiple="true"
                :chips="true"
                v-model="selectedDiscountProductTypes"
                :items="discountProductTypes"
                :loading="discountCatalogueLoading"
                :disabled="discountCatalogueDisabled"
                clearable
              >
              </v-select>
            </v-col>
            <v-col cols="6">
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" v-if="showDiscountProductCatalogue">
              <v-select
                label="Applied Product"
                :multiple="true"
                :chips="true"
                v-model="selectedDiscountProducts"
                :items="discountProducts"
                :loading="discountCatalogueLoading"
                :disabled="discountCatalogueDisabled"
                clearable
                @change="loadDiscountProductTerms()"
              >
              </v-select>
            </v-col>
            <v-col cols="6">
            </v-col>
          </v-row>
          <v-row dense v-if="discountProductTerms.length > 0">
            <v-col cols="12" v-for="(product, index) in discountProductTerms" :key="index">
              <v-row dense>
                <h5>{{ product.name }}</h5>
              </v-row>
              <v-row dense>
                <v-col cols="3" v-for="term in product.terms" :key="term.id">
                  <v-checkbox v-model="discountProductTerms[index]['enabled_terms'][term.value]"
                              :label="term.text"></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="text-right">
              <v-btn
                color="primary"
                :loading="processing"
                :disabled="processing || !discountTypeCapabilities
                  || (discountPartnerRequired && !partnerId)
                  || (isProductCoupon && rules.retailUserId(retailUserId) !== true)"
                @click="add"
              >Add</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import PartnerDropdown from '../../components/PartnerDropdown.vue';
import {
  buildDiscountCatalogueUrl,
  getDiscountTypeCapabilities,
} from '../../../plugins/discount-catalogue';

export default {
  name: 'Add',
  components: {
    PartnerDropdown,
  },
  async mounted() {
    await Promise.allSettled([
      this.getDiscountTypes(),
      this.getDiscountStatus(),
      this.getDiscountOperationTypes(),
    ]);
  },
  data() {
    return {
      partnerId: '',
      retailUserId: '',
      disableStack: false,
      discountValue: '',
      discountName: '',
      discountCode: '',
      selectedDiscountType: null,
      selectedDiscountStatus: null,
      selectedDiscountProductTypes: [],
      selectedDiscountOperationTypes: null,
      selectedDiscountProducts: [],
      selectedDiscountProductTerms: null,
      perUserTimes: 0,
      discountTypes: [],
      discountStatus: [],
      discountProductTypes: [],
      discountOperationTypes: [],
      discountProducts: [],
      discountProductsMap: {},
      discountProductTerms: [],
      discountCatalogueLoading: false,
      discountCatalogueRequestId: 0,
      discountProductTermRequestId: 0,
      processing: false,
      rules: {
        retailUserId: (value) => value === null || value === ''
          || (/^[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value)))
          || 'Enter a valid retail user ID.',
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
        discountCodeRequired: (value) => {
          if (this.discountCodeRequired) {
            return !!value || 'This field is required.';
          }
          return true;
        },
      },
    };
  },
  methods: {
    async getDiscountTypes() {
      try {
        const response = await this.$api.get('admin/discount-type');
        this.discountTypes = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        this.discountTypes = [];
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'Unable to load discount types. Please refresh and try again.',
        });
      }

      this.selectedDiscountType = this.discountTypes.length > 0
        ? this.discountTypes[0].value : null;
    },
    async getDiscountStatus() {
      this.discountStatus = await this.$gceCommon.getDropdown('admin/discount-status');
      this.selectedDiscountStatus = this.discountStatus[0].value;
    },
    async getDiscountProductTypes() {
      return this.$gceCommon.getDropdown(
        buildDiscountCatalogueUrl('admin/discount-product-type', this.partnerId),
      );
    },
    async getDiscountOperationTypes() {
      this.discountOperationTypes = await this.$gceCommon.getDropdown('admin/discount-operation-type');
    },
    async getDiscountProducts() {
      return this.$gceCommon.getDropdown(
        buildDiscountCatalogueUrl('admin/discount-product', this.partnerId),
      );
    },
    resetDiscountCatalogueSelections() {
      this.selectedDiscountProductTypes = [];
      this.selectedDiscountProducts = [];
      this.discountProductTerms = [];
      this.discountProductsMap = {};
      this.discountProductTermRequestId += 1;
    },
    async reloadDiscountCatalogue() {
      this.discountCatalogueRequestId += 1;
      const requestId = this.discountCatalogueRequestId;

      this.resetDiscountCatalogueSelections();
      this.discountProductTypes = [];
      this.discountProducts = [];

      if (!this.discountTypeCapabilities
        || !this.discountUsesProductCatalogue
        || (this.discountPartnerRequired && !this.partnerId)) {
        this.discountCatalogueLoading = false;
        return;
      }

      this.discountCatalogueLoading = true;
      const [productTypesResult, productsResult] = await Promise.allSettled([
        this.getDiscountProductTypes(),
        this.getDiscountProducts(),
      ]);

      if (requestId !== this.discountCatalogueRequestId) {
        return;
      }

      this.discountProductTypes = productTypesResult.status === 'fulfilled'
        ? productTypesResult.value : [];
      this.discountProducts = productsResult.status === 'fulfilled'
        ? productsResult.value : [];
      this.discountProducts.forEach((product) => {
        this.discountProductsMap[product.value] = product.text;
      });
      this.discountCatalogueLoading = false;
    },
    async loadDiscountProductTerms() {
      this.discountProductTermRequestId += 1;
      const requestId = this.discountProductTermRequestId;
      const productIds = Array.isArray(this.selectedDiscountProducts)
        ? [...this.selectedDiscountProducts] : [];

      this.$set(this, 'discountProductTerms', []);

      const results = await Promise.allSettled(productIds.map(async (productId) => {
        const url = buildDiscountCatalogueUrl(
          `admin/discount-product-term/${productId}`,
          this.partnerId,
        );
        const response = await this.$api.get(url);

        return {
          id: productId,
          name: this.discountProductsMap[productId],
          terms: response.data,
          enabled_terms: [],
        };
      }));

      if (requestId !== this.discountProductTermRequestId) {
        return;
      }

      this.$set(
        this,
        'discountProductTerms',
        results
          .filter((result) => result.status === 'fulfilled')
          .map((result) => result.value),
      );
    },
    add() {
      if (this.isProductCoupon && this.rules.retailUserId(this.retailUserId) !== true) {
        return;
      }
      this.processing = true;
      this.discountProductTerms.forEach((discountProductTerm, index) => {
        discountProductTerm.enabled_terms.forEach((enabledDiscountProductTerm, subindex) => {
          if (enabledDiscountProductTerm !== true || enabledDiscountProductTerm === null) {
            this.discountProductTerms[index].enabled_terms.splice(subindex, 1);
          }
        });
      });
      this.$api.post('admin/discount', {
        partner_id: this.partnerId,
        retail_user_id: this.isProductCoupon && this.retailUserId
          ? Number(this.retailUserId) : null,
        disable_stack: this.isProductCoupon && this.disableStack,
        discount_name: this.discountName,
        unique_code: this.discountCode,
        discount_type_id: this.selectedDiscountType,
        discount_status_id: this.selectedDiscountStatus,
        per_user_times: this.perUserTimes,
        value: this.discountValue,
        discount_product_types: this.selectedDiscountProductTypes,
        discount_products: this.selectedDiscountProducts,
        discount_product_terms: this.discountProductTerms,
        discount_operation_ids: this.selectedDiscountOperationTypes,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Discount is created successfully.',
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
        .catch((error) => {
          if (error.response) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.response.data.message || error.response.data,
            });
          } else {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.message,
            });
          }
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
  watch: {
    partnerId(newPartnerId, previousPartnerId) {
      if (`${newPartnerId || ''}` === `${previousPartnerId || ''}`) {
        return;
      }

      this.retailUserId = '';
      this.reloadDiscountCatalogue();
    },
    selectedDiscountType(newDiscountType, previousDiscountType) {
      if (newDiscountType === previousDiscountType) {
        return;
      }

      if (!this.isProductCoupon) {
        this.retailUserId = '';
        this.disableStack = false;
      }
      this.reloadDiscountCatalogue();
    },
  },
  computed: {
    isProductCoupon() {
      return [2, 3].includes(Number(this.selectedDiscountType));
    },
    discountTypeCapabilities() {
      return getDiscountTypeCapabilities(
        this.discountTypes,
        this.selectedDiscountType,
      );
    },
    discountPartnerRequired() {
      return this.discountTypeCapabilities
        ? this.discountTypeCapabilities.requiresPartner : false;
    },
    discountUsesProductCatalogue() {
      return this.discountTypeCapabilities
        ? this.discountTypeCapabilities.usesProductCatalogue : false;
    },
    showDiscountProductCatalogue() {
      return !this.discountTypeCapabilities || this.discountUsesProductCatalogue;
    },
    discountUsesOperationTypes() {
      return this.discountTypeCapabilities
        ? this.discountTypeCapabilities.usesOperationTypes : false;
    },
    discountCatalogueDisabled() {
      return !this.discountTypeCapabilities
        || this.discountCatalogueLoading
        || (this.discountPartnerRequired && !this.partnerId);
    },
    discountCodeRequired() {
      return this.discountTypeCapabilities
        ? this.discountTypeCapabilities.requiresCode : false;
    },
  },
};
</script>

<style>
</style>
